import { createRouter, createWebHistory } from 'vue-router'
//import Start from '../views/Start.vue'
import StartView from '../views/StartView.vue'


import TestProductList from '../views/test/TestProductList.vue'
import TestDataModels from '../views/test/TestDataModels.vue'
import OrderListView from '../views/OrderListView.vue'
import Products from '../views/product/ProductsView.vue'
import TestProductSearch from '../views/test/TestProductSearch.vue'
import TestSelectMc from '../views/test/TestSelectMcView.vue'
import TestImageCSS from '../views/test/TestImageCSS.vue'

import ProductDetails from '../views/product/product-details/ProductDetails.vue'
import NotFound from '../components/NotFound.vue'
import ResellerView from '../components/reseller/ResellerView.vue'
import ResellerNews from '../components/user/ResellerNews.vue'
import ResellerInformation from '../components/user/ResellerInformation.vue'

const routes = [

	

	{
		path: '/:productTypeKey?',
		name: 'StartView',
		props: true,
		component: StartView,
	},



	{
		path: '/test-products',
		name: 'TestProductList',
		component: TestProductList,
	},

	/*{
		path: '/products',
		name: 'Products',
		component: Products,
	},*/
	
	{
		path: '/:productTypeKey/products',
		name: 'Products',
		props: true,
		component: Products,
	},

	{
		path: '/:productTypeKey/product/:productId/:urlKey?',
		name: 'ProductDetails',
		props: true,
		component: ProductDetails,
	},
/*
	{
		path: '/product/:productId',
		name: 'ProductDetails',
		component: ProductDetails,
	},
	{
		path: '/:productTypeKey/product/:productId',
		name: 'ProductDetails2',
		component: ProductDetails,
	},
	{
		path: '/:productTypeKey/product/:productId/:key?',
		name: 'ProductDetails3',
		component: ProductDetails,
	},
	{
		path: '/product/:productId/:key?',
		name: 'ProductDetails4',
		component: ProductDetails,
	},
	*/
	{
		path: '/test-data-models',
		name: 'TestDataModels',
		component: TestDataModels,
	},

	{
		path: '/test-products-search',
		name: 'TestProductSerch',
		component: TestProductSearch,
	},

	{
		path: '/test-select-mc',
		name: 'TestSelectMc',
		component: TestSelectMc,
	},

	{
		path: '/test-image-css',
		name: 'TestImageCSS',
		component: TestImageCSS,
	},


	{
		path: '/user/order-list',
		name: 'OrderListView',
		component: OrderListView,
	},

	{
		path: '/aterforsaljare',
		name: 'Reseller',
		component: ResellerView,
	},

	{
		path: '/user/reseller-news',
		name: 'ResellerNews',
		component: ResellerNews,
	},

	{
		path: '/user/reseller-information',
		name: 'ResellerInformation',
		component: ResellerInformation,
	},

	{
		path: '/test',
		name: 'Test',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Test.vue')
	},

	{ path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else if (to.hash) {
			return {
				el: to.hash,
				behavior: 'smooth', // Optional smooth scrolling
			};
		
		} else {
			return { top: 0 }
		}
	},
})

export default router
